import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

export const hizmetFormFormSchema = z.object({
  firmaAdi: z.string({ required_error: 'Bu alan boş bırakılamaz.' }),
  adSoyad: z
    .string({ required_error: 'Bu alan boş bırakılamaz.' })
    .min(1, { message: 'Bu alan boş bırakılamaz.' }),
  telefon: z
    .string({ required_error: 'Bu alan boş bırakılamaz.' })
    .min(1, { message: 'Bu alan boş bırakılamaz.' }),
  konu: z
    .string({ required_error: 'Bu alan boş bırakılamaz.' })
    .min(1, { message: 'Bu alan boş bırakılamaz.' }),
  hizmetler: z
    .string({ required_error: 'Bu alan boş bırakılamaz.' })
    .min(1, { message: 'Bu alan boş bırakılamaz.' }),
  email: z
    .string({ required_error: 'Bu alan boş bırakılamaz' })
    .email({ message: 'Lütfen geçerli bir e-posta adresi giriniz.' })
    .min(1, { message: 'Bu alan boş bırakılamaz.' }),
  mesaj: z
    .string({ required_error: 'Bu alan boş bırakılamaz' })
    .min(1, { message: 'Bu alan boş bırakılamaz.' }),
})

export type hizmetFormFormSchemaType = z.infer<typeof hizmetFormFormSchema>
export const hizmetFormResolver = zodResolver(hizmetFormFormSchema)
